import React from "react";
import { Rating } from "react-simple-star-rating";
import { RxStar, RxStarFilled } from "react-icons/rx";

import {
  customerSurveyConstants,
  emptyString,
  questionTypeConstants,
  threeStar,
  SURVEY_STAR_ICON_SIZE,
} from "../../../constants";
import ReadOnlyTextarea from "../../shared/readOnlyTextarea";

const { DEFAULT_STAR_COLOR } = customerSurveyConstants;

const CustomerSurveyComponent = ({ responseJson }) => {
  return (
    <div data-testid="submitted-survey">
      {responseJson?.length > 0 &&
        responseJson.map((question, index) => (
          <React.Fragment key={question.questionOrder}>
            <div
              className="py-2 px-3"
              key={question.questionOrder}
              aria-label="question"
            >
              <div className="bg-white ">
                <p className="fw-bold mb-0 py-1">Question {index + 1}</p>
              </div>
              <small className="py-1 bold-6 mb-0">
                {question.questionText}
              </small>
              <div className="bg-white ">
                {/* Options selected on the bases of question types */}
                {question.questionTypeId ===
                  questionTypeConstants.STAR_RANKING_ID && (
                  <div className="py-1">
                    <Rating
                      readonly
                      allowHover={false}
                      fillColor={DEFAULT_STAR_COLOR}
                      initialValue={question.answer}
                      fillIcon={<RxStarFilled size={SURVEY_STAR_ICON_SIZE} />}
                      emptyIcon={
                        <RxStar
                          size={SURVEY_STAR_ICON_SIZE}
                          color={DEFAULT_STAR_COLOR}
                        />
                      }
                    />
                    {question.answer <= threeStar &&
                    question.starRatingTextBox &&
                    question.starRatingTextBox.trim() !== emptyString ? (
                      <div className="py-1" aria-label="textBox">
                        <ReadOnlyTextarea value={question.starRatingTextBox} />
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                )}
                {question.questionTypeId ===
                  questionTypeConstants.TEXTBOX_ID && (
                  <div className="py-1">
                    <ReadOnlyTextarea value={question.answer || emptyString} />
                  </div>
                )}
              </div>
            </div>
          </React.Fragment>
        ))}
    </div>
  );
};

export default React.memo(CustomerSurveyComponent);
